module.exports = __webpack_public_path__ + "static/media/battery-low.0516537a.svg";